import useBackward from "@/hooks/useBackward";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";

interface NavigationBackProps {
	to?: string;
}

const NavigationBack = (props: NavigationBackProps) => {
	const onClickBack = useBackward();
	return (
		<IconButton
			type="button"
			aria-label="Back"
			onClick={() => onClickBack(props.to)}
		>
			<KeyboardBackspaceIcon className="text-white" />
		</IconButton>
	);
};

export default NavigationBack;
